import React from 'react';

import DeleteMassModalConstructor from '../Forms/DeleteMassModalConstructor';

const ConfirmDeleteSelectedElement = ({ hideModal, data }) => {
  const itemIds = data.selectedItems;

  const deleteModalProps = {
    hideModal,

    DELETE_REQUEST_URL: data.DELETE_REQUEST_URL,
    DELETE_STATIC_HINT: 'Вы уверены, что хотите выбранные запись',
    DELETE_STATIC_VALUE: itemIds,
  };

  return <DeleteMassModalConstructor {...deleteModalProps} />
};

export default ConfirmDeleteSelectedElement;